import { useParams } from "react-router";
import { CompanyDataCard } from "@/services/backend/company/components/company-data-card";

export function CompanyDataRoute() {
  const { companyId } = useParams();

  return (
    <div className="grid gap-2">
      <CompanyDataCard companyId={companyId!} />
    </div>
  );
}
